import React, { useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import Modal from "../../UI/Modal/DeleteModal";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";

import CreateZuoraPaymentMethodModal from "../../UI/Modal/CreateZuoraPaymentMethodModal";
import BillingUpdate from "./BillingUpdate";

import { faTrashAlt, faMoneyCheck, faExclamation, faLongArrowAltUp, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { faCreditCard } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./Billing.module.scss";

import * as Utils from "../../Utils/BillingUtils";
import * as PaymentsActions from "../../../middleware/Store/Actions/PaymentsActions";


import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "BILLING_HISTORY";

const BillingHistory = (props) => {
    const intl = useIntl();
    const [methodSelected, setMethodSelected] = useState();
    const [progressSetAsDefault, setProgressSetAsDefault] = useState(false);
    const [progressDelete, setProgressDelete] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [modal, setModal] = useState(null);

    const getTypeOfCard = (type) => {
        return type === "CreditCard" ? faCreditCard : faMoneyCheck;
    }

    function statusDisplay(obj) {
        let state = Utils.getStatusOfCard(obj, intl);
        return (
            <span className={`badge badge-${state.style}`}>
                {state.label}
            </span>
        )
    }

    function methodDisplay(obj) {
        const style = obj.isDefaultPaymentMethod ? "grid-label text-primary" : "grid-label";

        return (
            <tr id="billingHistoryPaymentMethod"  key={"method-" + obj.Id}>
                <td style={{ verticalAlign: "middle; !important" }} className={style} >
                    <FontAwesomeIcon icon={getTypeOfCard(obj.Type)} size="2x" />
                </td>

                <td style={{ lineHeight: "initial" }}>
                    <span className={style} style={{ fontSize: "0.8rem" }}>{obj.Type === "CreditCard" ? obj.CreditCardType : obj.BankTransferType}</span><br />
                    <span className={style} style={{ fontSize: "0.8rem" }}>{obj.Type === "CreditCard" ? obj.CreditCardMaskNumber : obj.BankTransferAccountNumberMask}</span>
                </td>

                <td className={style}>
                    {obj.Type === "CreditCard" ? obj.CreditCardHolderName : obj.BankTransferAccountName}
                </td>

                <td className={style}>
                    {statusDisplay(obj)}
                </td>

                <td >
                    {!obj.isDefaultPaymentMethod &&
                        <span>
                            <Button
                                targetName="#deletePaymentMethod"
                                icon={faTrashAlt}
                                className="btn-grid"
                                disabled={obj.isDefaultPaymentMethod || progressDelete}
                                tooltipTitle={intl.messages.billingTooltipDelete}
                                spinner={progressDelete && obj.Id === methodSelected}
                                onClick={() => onActionDelete(obj.Id)}
                            />

                            <Button
                                targetName="#setPaymentMethodDefault"
                                icon={faLongArrowAltUp}
                                className="btn-grid ml-1"
                                disabled={Utils.isExpired(obj) || progressSetAsDefault}
                                tooltipTitle={intl.messages.billingTooltipSetAsDefault}
                                spinner={progressSetAsDefault && obj.Id === methodSelected}
                                onClick={(event) => onSetOnDefault(event, obj.Id)}
                            />
                        </span>}
                </td>
            </tr>
        );
    }

    const onActionDelete = (methodId) => {
        LogService.trace(LOG_TAG, "onActionDelete:" + methodId);

        setModal(
            <Modal
                id="deletePaymentMethod"
                title={intl.messages.billingDelete}
                icon={faExclamation}
                btnlabel={intl.messages.delete}
                showModalOnInit={true}
                onClick={() => onDeletePaymentMethod(methodId)}
            >
                <p>{intl.messages.billingDeleteMessage}</p>
            </Modal>
        );
    };

    function onDeletePaymentMethod(methodId) {
        LogService.info(LOG_TAG, "onDeletePaymentMethod");

        setProgressDelete(true);
        setMethodSelected(methodId);
        LogService.trace(LOG_TAG, "Delete payment method = " + methodId);
        props.deletePaymentMethod(props.user.id, methodId)
            .then(() => {
                LogService.info(LOG_TAG, "onDeletePaymentMethod successfully");
                setProgressDelete(false);
                setErrorMessage("");
            })
            .catch(errorPayload => {
                LogService.error(LOG_TAG, "onDeletePaymentMethod error");
                setProgressDelete(false);
                setErrorMessage(errorPayload.errorMessage);
            });
    };

    function onSetOnDefault(event, methodId) {
        LogService.info(LOG_TAG, "onSetOnDefault");

        event.preventDefault();
        setProgressSetAsDefault(true);
        setMethodSelected(methodId);
        LogService.trace(LOG_TAG, "Set as default = " + methodId);
        props.setAsDefault(props.user.id, methodId)
            .then(() => {
                LogService.info(LOG_TAG, "onSetOnDefault successfully");
                setProgressSetAsDefault(false);
                setErrorMessage("");
            })
            .catch(errorPayload => {
                LogService.error(LOG_TAG, "onSetOnDefault error");
                setProgressSetAsDefault(false);
                setErrorMessage(errorPayload.errorMessage);
            });
    };

    function onUpdatePaymentMethod() {
        LogService.trace(LOG_TAG, "Update payment method");
        const title = intl.messages.addBilling;
        const getComponent = (handleOnSuccess, handleOnFailed) => {
            return (
                <BillingUpdate
                    onActionSuccess={handleOnSuccess}
                    onActionFailed={handleOnFailed}
                />
            );
        }

        let footer =
            <div className={styles.billingIcons}>
                <img src="./images/adyen.png" alt="SecureAdyen" className="" />
                <img src="./images/pci-dss-compliant.png" alt="SecurePCI" className="" />
                <img src="./images/zuora.png" alt="SecureZuora" className="" />
            </div>;

        setModal(
            <CreateZuoraPaymentMethodModal
                title={title}
                icon={faCreditCard}
                iconColor="pink"
                getComponent={getComponent}
                footer={footer}
            />
        );
    };

    LogService.info(LOG_TAG, "Billing History");
    let methods = props.payments.map(method => (
        methodDisplay(method)
    ));

    let defaultMethod = null;
    if (props.defaultPayment)
        defaultMethod = methodDisplay(props.defaultPayment);

    return (
        <Card title={intl.messages.billingHistory}>

            {/* Instance of the popup to permit to create new payment method */}
            {modal}

            <div className={styles.container}>
                <table className="table">
                    <thead className="border-bottom border-primary">
                        {defaultMethod}
                    </thead>
                    <tbody>
                        {methods}
                    </tbody>
                </table>
            </div>

            <div className="d-flex mt-2" style={{ overflowWrap: "anywhere" }}>
                <div className="flex-shrink-0">
                    <Button
                        targetName="#updatePaymentMethod"
                        label={intl.messages.add}
                        icon={faPlusCircle}
                        className="btn-submit"
                        disabled={progressDelete || progressSetAsDefault}
                        toggleName="modal"
                        onClick={() => onUpdatePaymentMethod()}
                    />
                </div>
                {(errorMessage.length > 0) &&
                    <ErrorPanel size={ErrorSize.Small} className="p-0 pl-2">{errorMessage}</ErrorPanel>
                }
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        defaultPayment: Utils.getDefaultPaymentMethod(state.payments.data),
        payments: Utils.getOrderedPaymentMethod(state.payments.data)
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setAsDefault: (userId, paymentMethodId) => dispatch(PaymentsActions.setAsDefault(userId, paymentMethodId)),
        deletePaymentMethod: (userId, paymentMethodId) => dispatch(PaymentsActions.deletePaymentMethod(userId, paymentMethodId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingHistory)